export default [
  { text: 'salesOverview.table.webApp', value: 'web_app' },
  { text: 'salesOverview.table.terminal', value: 'terminal' },
  { text: 'salesOverview.table.wolt', value: 'wolt' },
  { text: 'salesOverview.table.uberEats', value: 'uber_eats' },
  { text: 'salesOverview.table.jet', value: 'jet' },
  { text: 'salesOverview.table.total', value: 'total' },
];
